// IP bazlı dil tespiti ve yönlendirme (Cloudflare uyumlu)
export const detectUserLanguage = async (): Promise<string> => {
  try {
    // Önce localStorage'dan kontrol et
    const savedLanguage = localStorage.getItem('broiler_language');
    if (savedLanguage) {
      return savedLanguage;
    }

    // Cloudflare ülke kodu kontrolü (en hızlı)
    const cfCountry = getCloudflareCFCountry();
    if (cfCountry) {
      console.log('Cloudflare country detected:', cfCountry);
      return cfCountry === 'TR' ? 'tr' : 'en';
    }

    // IP bazlı konum tespiti (fallback)
    const country = await detectCountryByIP();
    if (country === 'TR') {
      return 'tr';
    }
    
    return 'en';
  } catch (error) {
    console.log('IP detection failed, using browser language');
    
    // Son çare: tarayıcı dilini kontrol et
    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('tr')) {
      return 'tr';
    }
    
    return 'en'; // Varsayılan İngilizce
  }
};

// Cloudflare CF-IPCountry header'ından ülke kodunu al
const getCloudflareCFCountry = (): string | null => {
  try {
    // Cloudflare, CF-IPCountry header'ını JavaScript'te erişilebilir yapmaz
    // Ancak Cloudflare Workers veya Page Rules ile cookie'ye yazılabilir
    const cfCountryCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('cf-ipcountry='));
    
    if (cfCountryCookie) {
      return cfCountryCookie.split('=')[1];
    }
    
    return null;
  } catch (error) {
    return null;
  }
};

// IP bazlı ülke tespiti (fallback)
const detectCountryByIP = async (): Promise<string | null> => {
  try {
    // Birden fazla servis dene (güvenilirlik için)
    const services = [
      'https://ipapi.co/json/',
      'https://ip-api.com/json/',
      'https://ipinfo.io/json'
    ];

    for (const serviceUrl of services) {
      try {
        const response = await fetch(serviceUrl, {
          timeout: 3000 // 3 saniye timeout
        } as RequestInit);
        
        if (!response.ok) continue;
        
        const data = await response.json();
        
        // Farklı servislerin farklı field isimleri
        const countryCode = data.country_code || data.countryCode || data.country;
        
        if (countryCode) {
          console.log(`Country detected by ${serviceUrl}:`, countryCode);
          return countryCode;
        }
      } catch (serviceError) {
        console.log(`Service ${serviceUrl} failed:`, serviceError);
        continue;
      }
    }
    
    return null;
  } catch (error) {
    console.log('All IP detection services failed:', error);
    return null;
  }
};

export const getLanguageFromPath = (pathname: string): string | null => {
  const segments = pathname.split('/').filter(Boolean);
  const firstSegment = segments[0];
  
  if (firstSegment === 'tr') {
    return firstSegment;
  }
  
  // İngilizce için URL'de dil kodu yok, ana domainde kalıyor
  return null;
};

export const removeLanguageFromPath = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean);
  const firstSegment = segments[0];
  
  if (firstSegment === 'tr') {
    return '/' + segments.slice(1).join('/');
  }
  
  return pathname;
};

export const addLanguageToPath = (pathname: string, language: string): string => {
  const cleanPath = removeLanguageFromPath(pathname);
  
  // İngilizce için URL'de dil kodu yok, ana domainde kalıyor
  if (language === 'en') {
    return cleanPath;
  }
  
  return `/${language}${cleanPath === '/' ? '' : cleanPath}`;
};